import React from 'react';
import { twMerge } from 'tailwind-merge';

/* eslint-disable no-unused-vars */
const possible = [
  'w-[0%]',
  'w-[5%]',
  'w-[10%]',
  'w-[15%]',
  'w-[20%]',
  'w-[25%]',
  'w-[30%]',
  'w-[35%]',
  'w-[40%]',
  'w-[45%]',
  'w-[50%]',
  'w-[55%]',
  'w-[60%]',
  'w-[65%]',
  'w-[70%]',
  'w-[75%]',
  'w-[80%]',
  'w-[85%]',
  'w-[90%]',
  'w-[95%]',
  'w-[100%]',
];

const TableHeader = ({ column }) => {
  return (
    <th
      scope="col"
      className={twMerge(`px-1 sm:px-2 py-2 text-xs md:text-sm h-10 md:h-12 font-normal`, column.className)}
    >
      {column.object ? column.object : column.name}
    </th>
  );
};

export default TableHeader;
